import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../../api';


type RemoveOrderItemsParams = {
  productId?: number;
  orderItemId?: number | null;
  userId?: string;
};


const removeAllOrderItems = async ({ productId, orderItemId, userId }:RemoveOrderItemsParams) => {
    // Получаем все заказы Pending
    const { data: orders, error: orderError } = await supabase
        .from('orders')
        .select('id')
        .eq('created_by', userId)
        .eq('status', 'Pending');

    if (orderError || !orders?.length) {
        throw new Error(`No orders found: ${orderError?.message || 'Not found'}`);
    }

    const orderIds = orders.map(o => o.id);

    let deleteQuery = supabase.from('order_items').delete().in('order_id', orderIds);

    if (productId) {
        deleteQuery = deleteQuery.eq('product', productId);
    } else if (orderItemId) {
        deleteQuery = deleteQuery.eq('id', orderItemId);
    }

    const { error: deleteError } = await deleteQuery;

    if (deleteError) {
        throw new Error(`Failed to remove items: ${deleteError.message}`);
    }

    return { success: true };
};


export default function useRemoveAllProduct() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: removeAllOrderItems,
        onSuccess: () => {
            queryClient.invalidateQueries(['useGetOrdersInTheCart']);
            queryClient.invalidateQueries(['useGetOrders']);
        }
    });
}
